import { Button, Dropdown, type MenuProps } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { exportToCSV, exportToJSON, type ExportColumn } from '../utils/export';

interface ExportButtonProps<T extends Record<string, any>> {
  data: T[];
  columns: ExportColumn[];
  filename: string;
  disabled?: boolean;
}

export function ExportButton<T extends Record<string, any>>({
  data,
  columns,
  filename,
  disabled = false
}: ExportButtonProps<T>) {
  const handleExport = (format: 'csv' | 'json') => {
    const timestamp = new Date().toISOString().split('T')[0];
    const fullFilename = `${filename}_${timestamp}`;

    if (format === 'csv') {
      exportToCSV(data, columns, fullFilename);
    } else {
      exportToJSON(data, fullFilename);
    }
  };

  const menuItems: MenuProps['items'] = [
    {
      key: 'csv',
      label: 'CSV olarak indir',
      onClick: () => handleExport('csv'),
    },
    {
      key: 'json',
      label: 'JSON olarak indir',
      onClick: () => handleExport('json'),
    },
  ];

  return (
    <Dropdown menu={{ items: menuItems }} disabled={disabled || data.length === 0}>
      <Button icon={<DownloadOutlined />}>
        Dışa Aktar
      </Button>
    </Dropdown>
  );
}
